module.exports = __webpack_public_path__ + "static/media/DP_Neutral.d82c6e52.png";